import { Table, TableContainer } from '@material-ui/core';
import {
  AgentInSinglePaymentProviderContext,
  getAgentInSinglePaymentProviderContextByAgentId,
  Lender,
  MerchantStructure,
} from '@nemuru-eng/js-api-client';

import { TableBody } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/components/TableBody';
import { getTableColumns } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/constants/getTableColumns';
import { CredentialsType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialsType';
import withTableBodyWrapper from '@/components/modules/AgentDetail/ProvidersDetails/shared/HOC/withTableBodyWrapper';
import { SliderWarning } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/SliderWarning';
import { CircularLoading } from '@/components/shared/components/CircularLoading';
import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
interface AgentInLenderContextTableProps {
  agentId: string;
  channelId: string;
  lenders: Lender[];
  merchantStructure: MerchantStructure;
  credentialsType: CredentialsType;
  hideColumnsForDeleteMode?: boolean;
  agentsInSinglePaymentProviderContext?: AgentInSinglePaymentProviderContext[];
}
export const AgentInSinglePaymentProviderContextTable = ({
  agentId,
  channelId,
  lenders,
  merchantStructure,
  credentialsType,
  hideColumnsForDeleteMode,
}: AgentInLenderContextTableProps) => {
  const { data: agentInSinglePaymentProviderContext, loading: agentInSinglePaymentProviderLoading } = useCache(
    getAgentInSinglePaymentProviderContextByAgentId,
    { agentId },
  );
  const tableElementId = 'financial-entities-table-container';
  const { classes, stickyCellStyle, isScrollable } = useDefaultTable({
    tableElementId,
  });
  const columns = getTableColumns({ hideColumnsForDeleteMode });
  const TableBodyContentElement = withTableBodyWrapper(TableBody);

  if (agentInSinglePaymentProviderLoading) return <CircularLoading />;
  if (!agentInSinglePaymentProviderContext) return <PendingDataWarning type={PendingDataType.CREDENTIALS} />;

  return (
    <>
      <TableContainer id={tableElementId}>
        <Table>
          <CustomHeader columns={columns} tableProps={{ classes, stickyCellStyle }} />
          <TableBodyContentElement
            agentId={agentId}
            channelId={channelId}
            agentInContextArray={agentInSinglePaymentProviderContext}
            lenders={lenders}
            merchantStructure={merchantStructure}
            tableProps={{ classes, stickyCellStyle }}
            credentialsType={credentialsType}
            hideColumnsForDeleteMode={hideColumnsForDeleteMode}
          />
        </Table>
      </TableContainer>
      {isScrollable && <SliderWarning />}
    </>
  );
};
